import React, { memo, useCallback, useState, useEffect } from 'react';
import { FormSelect, FormSelectItem, FormSelectProps } from './FormSelect';
import { isEmail } from '@core/utils/form/validation/validators/isEmail';
import { FormControl } from '@core/utils/form';

export interface FormEmailSelectProps {
  emails: FormSelectItem<string>[];
}

export const FormEmailSelect = memo((props: FormEmailSelectProps & Omit<FormSelectProps<any>, 'items'>) => {
  const { emails, ...rest } = props;
  const [values, setValues] = useState<FormSelectItem<string>[]>(emails);

  useEffect(() => {
    setValues(emails);
  }, [emails]);

  const onValueAdd = useCallback(
    (value, control: FormControl) => {
      if (isEmail(value)) {
        setValues([...values, { value, label: value }]);
        control.setValue([...(control.value || []), value]);
      }
    },
    [values],
  );
  return <FormSelect {...rest} items={values} onAdd={value => onValueAdd(value, props.control)} />;
});
